export const app = {
  BACKEND_URL: 'https://foundx.smartssi.net'
  //BACKEND_URL: 'https://preprod-foundx.smartssi.net'
  //BACKEND_URL: 'https://foundx.com'
}